<template>
	<div class="addnote_wrap">
		<div class="top">
			<span>*</span>笔记内容        
		</div>
		<el-input
		  type="textarea"
		  placeholder="在此记录你的想法..."
		  v-model="noteCont"
		  maxlength="2000"
		  show-word-limit
		  resize="none"
		  @keydown.native="listen($event)"
		>
		</el-input>
		<div class="noteCheck">
			<el-checkbox v-model="checked">公开</el-checkbox>
		</div>
		<div class="btn">
			<a class="btn_itme btn_can" @click="cancel()">取 消</a>
			<a class="btn_itme btn_send" @click="addNote()">保 存</a>
		</div>
	</div>
</template>

<script>
	import * as api from "../../../../../api/noteApi";
	export default {
		name:'addnote',
		props:['catalogId'],
		data(){
			return {
				noteCont:'',
				checked:false,
				status: false
			}
		},
		methods:{
			cancel(){
				this.$emit('backNote',true);
			},
			addNote(){
				if(!this.isNull(this.noteCont)){
					if(this.status){
						return false;
					}
					this.status = true;
					
					let param = {
						content:this.noteCont,
						type:this.checked ? '0':'1',
						courseId:this.$route.query.id,
						classId:this.$route.query.classId,
						catalogId:this.catalogId
					};
					api.addNote(param).then(res=>{
						console.log(res);
						if(res.code == 0){
							this.$messageSuccess('添加笔记成功');
							this.$emit('backNote',true);
							this.status = false;
						}else{
							this.$messageError(res.msg);
							this.status = true;
						}
					}).catch(error=>{
						console.log(error);
					})
				}else{
					this.$messageWarning('笔记内容不能全为空或空格');
      		return
				}
			},
			isNull(str){
		    if (str == "") return true;
		    var regu = "^[ ]+$";
		    var re = new RegExp(regu);
		    return re.test(str);
			},
			listen(e){
				if (event.keyCode === 13 && this.noteCont == "") {
	        event.preventDefault() // 阻止浏览器默认换行操作
	        return false
		    }
			}
		}
	}
</script>

<style scoped lang="scss">
	.addnote_wrap {
		.top {
			margin-bottom: 12px;
			font-size: 14px;
			span {
				color: #F43D3D;
			}
		}
		/deep/ .el-textarea__inner {
			height: 240px;
		}
		.noteCheck {
			height: 56px;
			line-height: 56px;
			border-bottom:1px solid rgba(230,230,230,1);
		}
		.btn {
			margin-top: 24px;
			display: flex;
			justify-content: center;
			align-items: center;
			.btn_itme {
				float: left;
				width:96px;
				height:34px;
				text-align: center;
				line-height: 34px;
				border-radius:4px;
				color: #fff;
				cursor: pointer;
			}
			.btn_can {
				background: #B9D6FF;
				margin-right: 24px;
				&:hover {
					background: #5C9CF7;
				}
			}
			.btn_send {
				background: #5397F7;
				&:hover {
					background: #2A77E3;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/note/addNote.vue